import { IMenuRoute, ISubMenuRoute } from '~/types/sidebar-menu.type'

export const useSidebar = (param: IMenuRoute | ISubMenuRoute) => {
  const route = useRoute()
  const router = useRouter()

  const isActive = computed(() => {
    const splitPath = route.fullPath.split(/[/#?]/)
    return splitPath[param.depth] === param.value.split('/')[0]
  })

  const isParentActive = computed(() => {
    if ('parentUrl' in param) {
      const splitPath = route.fullPath.split('/')
      return splitPath[1] === param.parentUrl.split('/')[0]
    }
    return false
  })

  const sidebarClick = () => {
    if (param.children && param.children.length) {
      if ('parentUrl' in param) {
        router.push(`/${param.parentUrl}/${param.value}/${param.children[0].value}`)
        return
      }
      router.push(`/${param.value}/${param.children[0].value}`)
      return
    }
    if ('isExternalLink' in param && param.isExternalLink) {
      window.open(param.externalLink, '_blank')
      return
    }
    if ('parentUrl' in param) {
      router.push(`/${param.parentUrl}/${param.value}`)
    } else {
      router.push(`/${param.value}`)
    }
  }

  return {
    isActive,
    isParentActive,
    sidebarClick
  }
}